import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { VproService } from 'src/app/service/vpro/vpro.service';
import { Utils } from 'src/app/common/utils';
import Swal from "sweetalert2";
import { UntypedFormBuilder, Validators, UntypedFormControl, FormArray, UntypedFormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { AllPatient } from 'src/app/models/patient';
import { formatDate } from "@angular/common";
import { NgbCalendar, NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { StdioNull } from 'child_process';
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});
@Component({
  selector: 'app-patient-account',
  templateUrl: './patient-account.component.html',
  styleUrls: ['./patient-account.component.css']
})
export class PatientAccountComponent implements OnInit {
  public patientForm: UntypedFormGroup;
  patient: AllPatient;
  dateFormat = Utils.DATE_FORMAT;
  gender = Utils.GENDER;
  maxDate = Utils.today;
  minDate = Utils.minDobDate;
  relation = Utils.RELATION;
  validOTP: boolean = false;
  validateNewOTP: boolean = false;
  phone: number;
  oldPhone: number = 0;
  totalMembers = [];
  wrongOTP: boolean = false;
  currentDate = Utils.maxDate;
  miniDate = Utils.miniDate;
  dateTimeChangeEvent: any;
  date: NgbDate = new NgbDate(1789, 7, 14);
  constructor(
    private router: Router,
    private calendar: NgbCalendar,
    private service: VproService,
    private spinner: NgxSpinnerService,
    private _formBuilder: UntypedFormBuilder,
    public formatter: NgbDateParserFormatter
  ) {
    this.patientForm = this._formBuilder.group({
      first_name: ["", [Validators.required, Validators.maxLength(30), Validators.pattern(Utils.alphaSpaceRegex)]],
      last_name: ["", [Validators.required, Validators.maxLength(30), Validators.pattern(Utils.alphaSpaceRegex)]],
      dob: ["", [Validators.required]],
      email_id: [""],
      gender: ["", [Validators.required]],
      relation: ["", [Validators.required]],
      contact_no: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern(Utils.numberRegex)]],
      otp: [''],
      universal_id: [''],
      pid: ['']
    });
  }

  ngOnInit() {
    this.loadPatient();
  }

  loadPatient() {
    this.spinner.show();
    this.service.getPatientById(localStorage.getItem("uid"), '?fields=members').subscribe(res => {
      this.spinner.hide();
      if (res) {
        this.fetchMembers(res);
        this.patchPatientValues();
      }

    }, err => {
      this.spinner.hide();
    });
  }

  fetchMembers(data) {
    // let selfPatient = {};
    // let valuesToAdd = ['first_name', 'last_name', 'pid', 'email_id', 'contact_no', 'dob', 'gender', 'relation', 'universal_id'];
    // for (let val of valuesToAdd) {
    //   if (data[val]) selfPatient[val] = data[val];
    // }
    if (!data.members || data.members.length === 0) data.members = [];
    // data.members.unshift(selfPatient);
    this.totalMembers = data.members;
    // first member will be selected by default
    this.patient = this.totalMembers && this.totalMembers.length > 0 ? this.totalMembers[0] : null;
  }

  patchPatientValues() {
    if (this.patient) {
      this.oldPhone = this.patient.contact_no;
      // bind form values
      let valuesToBind = ['first_name', 'last_name', 'pid', 'email_id', 'contact_no', 'dob', 'gender', 'relation', 'universal_id'];
      let patchVal = {};
      for (let val of valuesToBind) {
        if (this.patient[val] !== this.patient['dob']) {
          if (this.patient[val]) patchVal[val] = this.patient[val];
        }
      }
      // console.log("this.patient[dob]", this.patient['dob'])
      let startDate = this.patient['dob'].split('-');
      this.patientForm.patchValue({
        dob: { year: parseInt(startDate[0]), month: parseInt(startDate[1]), day: parseInt(startDate[2]) }
      })

      this.patientForm.patchValue(patchVal);
    }
  }

  selectPatient(pid) {
    if (pid) {
      this.patient = this.totalMembers.filter(pat => pat.pid == pid)[0];
      this.patchPatientValues();
    }
  }

  getControl(field: string): UntypedFormControl {
    return this.patientForm.get(field) as UntypedFormControl;
  }

  public updatePaient() {
    let data = {
      ...this.patientForm.value,
    };
    console.log("data", data)
    // Remove any empy fields
    data = Utils.removeNullAndEmpty(data);
    data['pid'] = parseInt(this.patientForm.value.pid);
    if (data.dob) {
      // data.dob = formatDate(data.dob, "yyyy-MM-dd", "en-US");
      data.dob = data.dob.year + "-" + data.dob.month + "-" + data.dob.day
    }
    if (this.phone) data['contact_no'] = this.phone;
    if (data['relation']) {
      for (let r of this.relation) {
        if (r.key == data['relation'])
          data['relation'] = r.value;
      }
    }
    delete data['universal_id'];
    this.spinner.show();
    this.service.updatePatient(data['pid'], data).subscribe(
      (res) => {
        this.spinner.hide();
        // SweetAlert
        this.showToast('success', "Patient profile has been updated successfuly");
        this.router.navigate(["/patient/members"]);
      },
      (error) => {
        this.spinner.hide();
        let message;
        if (error && error.error && error.error.message && error.error.message.message) {
          message = error.error.message.message;
        }
        else message = "Something went wrong. Couldn't update profile."
        this.showToast('error', message);
      }
    );
  }

  cancel() {
    this.router.navigate(["/patient/members"]);
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title
    });
  }

  requestOTP() {
    if (this.patientForm.value.contact_no) {
      if (this.patientForm.value.otp)
        return;
      if (!this.patientForm.value.contact_no.match(Utils.numberRegex) || this.patientForm.value.contact_no.length != 10) {
        this.showToast("error", "Invalid Contact No, Please enter a valid contact number");
        this.patientForm.controls["contact_no"].reset();
        return;
      }

      if (this.patientForm.value.contact_no.match(this.oldPhone)) {
        this.showToast("error", "This number is same as the number provided before, Please enter new number if you want to change your contact number")
        return;
      }
      this.spinner.show();
      this.service
        .requestOTP({ contact_no: this.patientForm.value.contact_no })
        .subscribe(
          (res) => {
            this.spinner.hide();
            this.showToast("success", res.message);
            this.validateNewOTP = true;
            this.spinner.hide();
          },
          (error) => {
            console.log(error);
            this.spinner.hide();
            this.showToast("error", "Something went wrong. Please try again.");
          }
        );
    }
  }

  validateOTP() {
    if (this.validOTP)
      return;
    if (this.patientForm.value.contact_no && this.patientForm.value.otp) {
      this.spinner.show();
      this.service
        .validateOTP({
          contact_no: this.patientForm.value.contact_no,
          otp: this.patientForm.value.otp,
        })
        .subscribe(
          (res) => {
            this.spinner.hide();
            this.showToast("success", res.message);
            this.otpValidated();
          },
          (err) => {
            console.log(err);
            this.spinner.hide();
            let message =
              err && err.error && err.error.message && err.error.message.message
                ? err.error.message.message
                : "Something wrong. Couldn't delete appointment.";
            this.showToast("error", message);
            if (err.error.message.message) {
              this.wrongOTP = true;
              return;
            }

          }
        );
    }
  }

  otpValidated() {
    this.wrongOTP = false;
    this.phone = this.patientForm.value.contact_no;
    this.patientForm.controls["contact_no"].disable();
    this.patientForm.controls["otp"].disable();
    this.validOTP = true;
  }


}
